import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRangePicker = ({ onDateChange, icon = "bx bx-calendar" }) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const today = new Date();

    const handleDateChange = (update) => {
        setDateRange(update);
        onDateChange(update); // Callback for parent to receive the dates
    };

    return (
        <div className="date-picker-contanier">
            <ReactDatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={handleDateChange}
                maxDate={today}
                isClearable
                placeholderText="Custom Date"
                dateFormat="MM/dd/yyyy"
            />
            {startDate || endDate ? null : <i className={`${icon} calendar-icon`}></i>}
        </div>
    );
};

export default DateRangePicker;
